/* global PipelineDeals */

export default () => `https://${PipelineDeals.aws.s3_bucket_name}.s3.amazonaws.com`
